import React from 'react';
import { Link } from 'react-router-dom';
import Card from 'ui/views/cards/Card';
import Logo from 'ui/domain/Logo';
import Button from 'ui/elements/buttons/Button';
import { CompanyCardDTO } from 'types/company';
import { companyUrls } from 'urls';
import { notEmpty } from 'util/arrayUtils';

interface Props {
  company: CompanyCardDTO;
  onAdd: () => void;
  isAdding: boolean;
}

/** A company to add to a list: logo, name, what it has in common with the list, and an add button. */
export default function SuggestionCard({ company, onAdd, isAdding }: Props) {
  const facts = [
    company.industries[0]?.name,
    company.fundingStage?.name,
    company.hasActiveFundingRound ? 'Raising' : undefined,
  ].filter(notEmpty);

  return (
    <Card type="dashed" padding="half">
      <div className="u-flex u-flex-align-center u-flex-space-between u-flex--gap-half">
        <Link
          to={companyUrls.overview(company.details.slug, 'profile')}
          className="u-flex u-flex-align-center u-flex--gap-half"
          style={{ minWidth: 0 }}
        >
          <Logo type="company" size={36} url={company.details.logoURL} />
          <div style={{ minWidth: 0 }}>
            <div className="text-h4 u-ellipsis">{company.details.name}</div>
            <div className="text-metadata u-ellipsis">{facts.join(' · ')}</div>
          </div>
        </Link>
        <Button kind="secondary" size="small" onClick={onAdd} isLoading={isAdding}>
          + Add
        </Button>
      </div>
    </Card>
  );
}
